import request from '@/utils/request'

// 获取角色列表
export function listCharacter(query) {
  return request({
    url: '/character/list',
    method: 'get',
    params: query
  })
}

// 获取角色详情
export function getCharacter(characterId) {
  return request({
    url: `/character/${characterId}`,
    method: 'get'
  })
}

// 新增角色
export function addCharacter(data) {
  return request({
    url: '/character',
    method: 'post',
    data: data
  })
}

// 修改角色
export function updateCharacter(data) {
  return request({
    url: '/character',
    method: 'put',
    data: data
  })
}

// 删除角色
export function delCharacter(characterId) {
  return request({
    url: `/character/${characterId}`,
    method: 'delete'
  })
}

// 导出角色
export function exportCharacter(query) {
  return request({
    url: '/character/export',
    method: 'get',
    params: query
  })
}

// 更新角色状态
export function updateCharacterStatus(characterId, status) {
  return request({
    url: `/character/status`,
    method: 'put',
    params: {
      characterId,
      status
    }
  })
}

// 获取角色选择框列表
export function getCharacterOptions() {
  return request({
    url: '/character/options',
    method: 'get'
  })
}